// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_a8abbb', '__Roboto_Fallback_a8abbb'"},"className":"__className_a8abbb"};